import React, { Component } from 'react';

export class ResetPasswordSuccess extends Component {

    render() {
        return (
            <div>
                <h4>Password Reset Successful!</h4>
				<p>New password request initiated. </p>
				<p>An email has been sent to your registered email to set your new password. Please follow the instructions in that email in order to complete the reset process. Thank you.</p>
            </div>
        );
    }
}
